// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appPOSShifts/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appPOSShifts/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/POSShifts/List', { params })
  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: response.data
  }
})

export const getUnAssigned = createAsyncThunk('appPOSShifts/getUnAssigned', async (params, { dispatch }) => {
  dispatch(setLoading({ getUnAssigned: true }))
  const response = await axios.get(`/Defaults/GetBranchTillUnassignedShifts/${params.tillId}`, { params })
  dispatch(setLoading({ getUnAssigned: false }))
  return {
    params,
    data: response.data
  }
})

export const appPOSShifts = createSlice({
  name: 'appPOSShifts',
  initialState: {
    data: [],
    un_data: [],
    totalRecords: 1,
    params: {},
    loadingState: { getData: false, getUnAssigned: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        state.totalRecords = action.payload.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(getUnAssigned.fulfilled, (state, action) => {
        state.un_data = action.payload.data.data
        state.totalRecords = action.payload.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appPOSShifts.reducer
